import { Route } from '@angular/router';
import { ROUTE_PATH } from '../../routing/RoutePath.const';

export const feedbackProcessPagesRoutes: Route[] = [
  {
    path: ROUTE_PATH.FEEDBACK_EMOTION,
    loadChildren: () =>
      import('./feedback-emotion-page/feedback-emotion-page.module').then(
        (m) => m.FeedbackEmotionPageModule
      ),
  },
  {
    path: ROUTE_PATH.FEEDBACK_INTERNAL_DETAILS,
    loadChildren: () =>
      import(
        './feedback-internal-details-page/feedback-internal-details-page.module'
      ).then((m) => m.FeedbackInternalDetailsPageModule),
  },
  {
    path: ROUTE_PATH.FEEDBACK_INTERNAL_SUCCESS,
    loadChildren: () =>
      import(
        './feedback-internal-success-page/feedback-internal-success-page.module'
      ).then((m) => m.FeedbackInternalSuccessPageModule),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: ROUTE_PATH.FEEDBACK_EMOTION,
  },
];
